<script>
  import { Router, Link, Route } from "svelte-routing";
  import Form from "./routes/Form.svelte";
  import Thanks from "./routes/Thanks.svelte";
  import Error from "./routes/Error.svelte";

  export let url = "";
</script>

<style>
  :global(body) {
    padding: 0;
    background-color: #fdf1e2;
  }
  :global(main) {
    height: 100vh;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  :global(a) {
    color: #333 !important;
  }
  :global(h2) {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
</style>

<Router {url}>
  <div>
    <Route path="thanks" component={Thanks} />
    <Route path="error" component={Error} />
    <Route path="/">
      <Form />
    </Route>
  </div>
</Router>
